var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1889 7.5L13.5492 11.3293L15.9904 12.7439L20.1889 10.3293L24.3877 12.7439L26.8287 11.3293L20.1889 7.5Z",
    fill: "#FFFBFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3877 14.7441L26.8287 16.1587V18.988L22.6302 21.4027V26.232L20.1889 27.6465L17.7479 26.232V21.4027L13.5492 18.988V16.1587L15.9904 14.7441L20.1889 17.1587L24.3877 14.7441Z",
    fill: "#FFFBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8288 20.9878V23.8171L24.3878 25.2318V22.4025L26.8288 20.9878Z",
    fill: "#FFFBFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3633 27.2317L28.562 24.817V19.9877L31.003 18.5732V26.2317L24.3633 30.061V27.2317Z",
    fill: "#FFFBFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5621 15.1584L26.1211 13.7437L28.5621 12.3291L31.0031 13.7437V16.5731L28.5621 17.9876V15.1584Z",
    fill: "#FFFBFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7479 31.0851V28.2559L20.1889 29.6706L22.6302 28.2559V31.0851L20.1889 32.4999L17.7479 31.0851Z",
    fill: "#FFFBFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9904 25.2318L13.5492 23.8171V20.9878L15.9904 22.4025V25.2318Z",
    fill: "#FFFBFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1889 15.1584L17.7479 13.7437L20.1889 12.3291L22.6302 13.7437L20.1889 15.1584Z",
    fill: "#FFFBFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2573 13.7437L11.8162 15.1584V17.9876L9.375 16.5731V13.7437L11.8162 12.3291L14.2573 13.7437Z",
    fill: "#FFFBFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 18.5732L11.8162 19.9877V24.817L16.0147 27.2317V30.061L9.375 26.2317V18.5732Z",
    fill: "#FFFBFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.992faf61bd32f9aa2c3e429f4942fba2.svg";
export { ForwardRef as ReactComponent };